var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","max-width":"560px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('r-cookie-consent',{attrs:{"form":_vm.form},on:{"onSetConsent":_vm.onSetConsent,"onDeclineAll":_vm.onDeclineAll}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }